import { useQuery } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import STALE_TIMES from '../common/stale-times'
import useApi from '../use-api'

const useReflectionPrompts = ({
    offset,
    limit,
    startDate,
    endDate
} = {}) => {

    const cacheKeys = useCacheKeys()
    const { api, url, endpoints } = useApi()

    const filters = {
        offset,
        limit,
        startDate,
        endDate
    }
    

    const { data, isLoading } = useQuery(
        [cacheKeys.REFLECTION_PROMPTS, filters],

        () => api.get(url(endpoints.reflectionPrompts, {}, filters )),
        {
            staleTime: STALE_TIMES.HOUR
        }
    )

    return {
        reflectionPrompts: data ? data.items : [],
        total: data ? data.total : 0,
        isLoading,
    }
}

export default useReflectionPrompts